import { Row, Spacer } from '@components/1-atoms/Miscellaneous';
import Text from '@components/1-atoms/Text';
import { IconButton } from '@components/2-molecules/Buttons';
import styled from '@emotion/native';
import React, { FC } from 'react';

import Close from '@assets/icons/Close';
import setTheme from '@lib/theme';
import { LinearGradient /* , LinearGradientProps */ } from 'expo-linear-gradient';
import { useSafeAreaInsets } from 'react-native-safe-area-context';


const Container = styled(LinearGradient)`
  width: 100%;
`;

const CloseButton = styled(IconButton)`
  align-self: flex-end;
  background-color: ${({ theme }: any) => `${theme.white}`};
  border-radius: 5px;
  width: auto;
`;

const Content = styled(Row)`
  align-items: center;
  margin: auto;
  width: 100%;
  padding: 0px 9px;
  `;
// width: ${({ theme }: any) => `${Math.min(500, theme.contentWidth)}px`};


type Props = {
  title?: any;
  closable?: boolean;
  onClose?: () => void;
};

const theme = setTheme('light');
export const Header: FC<Props> = ({ title, onClose, closable = true, ...props }) => {

  const insets = useSafeAreaInsets();
  // Address possible notch on some devices:
  const notchSpace = Math.round(insets.top / 12);

  return (
    <Container colors={["#0059D4", "#013174", "rgba(0, 0, 0, 0.5)"]} locations={[0, 0.9999, 1]} >
      <Spacer h={notchSpace} />

      <Content>
        {(title || onClose) && <Spacer h={1} />}
        {title && <Text large bold color={theme.pallete.white}>{title}</Text>}
        {closable && onClose && <CloseButton icon={<Close fill={theme.pallete.gray_3} />} onPress={onClose} />}
        {(title || onClose) && <Spacer h={1} />}
      </Content>
    </Container>
  );
};

export default Header;